import './GuardianOfZone.css';

export default function TaskGuardian() {
  return (
    <svg className="guardian-svg guardian-task" viewBox="0 0 100 150" role="img">
      <title>Explorador — El Ranger, a media zancada</title>
      <path d="M64 30 C86 34 96 54 90 80 C98 74 98 56 94 40" fill="none" className="g-stroke-a g-drift" strokeWidth="6" strokeLinecap="round" opacity="0.55" />
      <g transform="rotate(8 50 25)">
        <path d="M50 10 C41 10 35 18 37 28 C38 34 42 38 50 38 C58 38 62 34 63 28 C65 18 59 10 50 10 Z" className="g-fill-a g-stroke-bg" strokeWidth="1.3" opacity="0.92" />
        <polygon points="42,26 50,34 58,26 53,21 50,27 47,21" className="g-fill-core" />
      </g>
      <path d="M40 36 C25 45 18 55 20 70" fill="none" className="g-stroke-a" strokeWidth="5" strokeLinecap="round" opacity="0.88" />
      <circle cx="20" cy="70" r="3.2" className="g-fill-a g-stroke-bg" strokeWidth="1" />
      <path d="M66 40 C75 45 80 50 82 45" fill="none" className="g-stroke-a" strokeWidth="5" strokeLinecap="round" opacity="0.88" />
      <circle cx="82" cy="45" r="3.2" className="g-fill-a g-stroke-bg" strokeWidth="1" />
      <path d="M40 36 L66 40 L74 66 L54 74 L34 64 Z" className="g-fill-a g-stroke-bg" strokeWidth="1.4" opacity="0.9" />
      <path d="M66 40 L86 30 L92 40 L74 54 Z" className="g-fill-a g-stroke-bg" strokeWidth="1.2" opacity="0.85" />
      <circle cx="89" cy="34" r="3.2" className="g-fill-a g-stroke-bg" strokeWidth="1" />
      <path d="M34 64 L14 74 L10 86 L30 82 Z" className="g-fill-a g-stroke-bg" strokeWidth="1.2" opacity="0.85" />
      <path d="M50 70 L36 90 L18 148 L36 148 L52 100 Z" className="g-fill-a g-stroke-bg" strokeWidth="1.4" opacity="0.88" />
      <path d="M54 74 L74 88 L86 130 L70 138 L58 96 Z" className="g-fill-a g-stroke-bg" strokeWidth="1.4" opacity="0.88" />
      <polygon points="10,148 34,148 30,140 12,141" className="g-fill-a g-stroke-bg" strokeWidth="1" />
      <polygon points="64,140 88,132 90,140 68,148" className="g-fill-a g-stroke-bg" strokeWidth="1" />
    </svg>
  );
}
